// src/blog/blogData.js
// Blog posts metadata

const BLOG_POSTS = [
  {
    id: "mern-stack-guide",
    slug: "mern-stack-guide",
    title: "How to Build a Full-Stack App with MERN Stack",
    date: "2025-05-10",
    tags: ["MERN", "React", "Node.js", "MongoDB"],
    excerpt:
      "Complete guide to building production-ready full-stack applications using MongoDB, Express, React, and Node.js.",
    readTime: "8 min read",
  },
  {
    id: "python-web-scraping",
    slug: "python-web-scraping",
    title: "Python Web Scraping with Selenium & BeautifulSoup",
    date: "2025-05-05",
    tags: ["Python", "Selenium", "BeautifulSoup", "Automation"],
    excerpt:
      "Step-by-step tutorial for automated data extraction using Python, Selenium WebDriver, and BeautifulSoup4.",
    readTime: "6 min read",
  },
  {
    id: "flutter-vs-react-native",
    slug: "flutter-vs-react-native",
    title: "Flutter vs React Native in 2025 - Which to Choose?",
    date: "2025-04-28",
    tags: ["Flutter", "React Native", "Mobile Development"],
    excerpt:
      "Honest comparison of Flutter and React Native for cross-platform mobile development in 2025.",
    readTime: "5 min read",
  },
];

export default BLOG_POSTS;

